import { FC } from 'react';
import ProImage, { ProImageProps } from './image';
import ProPreviewGroup from './previewGroup';
import { ImageProps } from 'antd/lib/image';

export type IImageComponent = FC<ProImageProps> & {
  PreviewGroup: FC<ImageProps>;
};

const TransImage = ProImage as IImageComponent;
TransImage.PreviewGroup = ProPreviewGroup;

export default TransImage;
